import { getTimeUntilString } from '../selectors/userConfigSelectors';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import ClockRegular from 'owa-fluent-icons-svg/lib/icons/ClockRegular';
import type { DisplayDate } from 'owa-datetime';
import { observableNow } from 'owa-observable-datetime';
import * as React from 'react';
import { getThemeColorScheme } from 'owa-color-utils/lib/colorUtils';

import styles from './AgendaEventTimeUntilView.scss';

export interface TimeUntilViewProps {
    startDate: DisplayDate;
    endDate: DisplayDate;
    containerClassName: string;
}

export const TimeUntilView = observer(function TimeUntilView(props: TimeUntilViewProps) {
    const { startDate, endDate, containerClassName } = props;

    const themeColorScheme = getThemeColorScheme();
    const textColor = themeColorScheme.accessibleText?.calPrimaryBackground;

    return (
        <div className={containerClassName}>
            <div className={styles.innerContainer} style={{ color: textColor }}>
                <Icon iconName={ClockRegular} className={styles.clockIcon} />
                <span>{getTimeUntilString(startDate, endDate, observableNow())}</span>
            </div>
        </div>
    );
});
